import React, { useState, useEffect } from 'react';
import { UtilityService } from '../../../services/UtilityService';
import { Dialog, DialogTitle, DialogContent, Tooltip } from '@mui/material';
import { CancelWhiteIcon, DownloadIcon } from '../../../icon';
import * as selector from '../../../selectors/selectors';
import { useSelector } from 'react-redux';
import AnimateLoaderComponent from "../../shared/loaders/animate-loader.component";
import IamgeLoader from "../../shared/loaders/image-loading-animation.json";


// const useStyles = makeStyles(() => ({
//     textMedia: {
//         width: "50px !important",
//         height: 50,
//     },
//     media: {
//         width: 'auto',
//         height: 200
//     }
// })) as any;

interface IProps {
    open?: boolean;
    MediaUrl: string;
    MediaType: string;
    mediaDisplay?: () => void;
    fileDownload?: () => void;
    classname?: any;
    controls: boolean;
    onClose: () => void;
    senderName: string;
    IsWidget?: boolean;
}

const ImageOrVideo: React.FC<IProps> = (props: IProps) => {
    const classes = {}
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)


    const [url, setUrl] = useState<string>();
    const [whRatio, setWhRatio] = useState<number>();
    const [isLoading, setIsloading] = useState<boolean>(false);

    useEffect(() => {
        if (!!props.MediaUrl) {
            setIsloading(true)
            UtilityService.convertUrlToBlob(props.MediaUrl).then(res => {
                setUrl(res);
                setIsloading(false)
            });
        }
    }, []);

    const handleOnClick = (event: React.MouseEvent<(HTMLImageElement | HTMLVideoElement), MouseEvent>) => {
        console.log("clicked");
        // event.preventDefault();
        props.mediaDisplay?.call(props);
    };

    return (
        props.open ?
            <Dialog fullScreen open={props.open} onClose={props.onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" PaperProps={{ classes: { root: "bg-transparent box-shadow-none" } }} >
                <DialogTitle id="alert-dialog-title" className={`bg-color-primary-accent color-secondary`}>
                    {!IsMobileDevice ? <div className={`d-flex`}>
                        <span className={"h1-regular "}>{props.senderName}</span>
                        <div className={`ml-auto d-flex my-auto`}>
                            <Tooltip title='Download' placement='bottom-start'><span className={`mr-4 `} onClick={props.fileDownload}><DownloadIcon className={`c-pointer`} /></span></Tooltip>
                            <Tooltip title='Close' placement='bottom-start'><span className={`c-pointer`}><CancelWhiteIcon onClick={props.onClose} /></span></Tooltip>
                        </div>
                    </div> :
                        <div className={`d-flex`}>
                            <Tooltip title='Close' placement='bottom-start'><span className={`c-pointer d-flex mr-2 my-auto`}><CancelWhiteIcon onClick={props.onClose} /></span></Tooltip>
                            <span className={"h3-semibold my-auto"}>{props.senderName}</span>
                            <div className={`ml-auto d-flex my-auto`}>
                                {
                                    IsTeamsApp ? null : <> <Tooltip title='Download' placement='bottom-start'><span ><DownloadIcon onClick={props.fileDownload} className={`c-pointer`} /></span></Tooltip> </>
                                }
                            </div>
                        </div>
                    }
                </DialogTitle>
                <DialogContent className={`d-flex justify-center align-center bg-transparent`} dividers>
                    <div className='d-flex justify-center align-center'>
                        {props.MediaType === "image" ?
                            <img src={url} alt={"Media"} className={`${props.classname} ${props.IsWidget ? "w-p-100 min-w-15 MuiInputBase-input" : "h-v-70"}`} onClick={handleOnClick} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} />
                            :
                            <video controls={props.controls} controlsList="nodownload" src={url} onClick={handleOnClick} className={`display-video`} />
                        }

                    </div>
                </DialogContent>
            </Dialog> :
            <div className='d-flex justify-center align-center'>
                {props.MediaType === "image" ?
                    isLoading ? < AnimateLoaderComponent LoaderAnimation={IamgeLoader} className={`${props.IsWidget && " bg-color-secondary"} w-p-100 max-w-15 MuiInputBase-input`} /> : <img src={url} alt={"Media"} className={`${props.classname} ${props.IsWidget && "bg-color-live-chat-widget-hist-background"} w-p-100 min-w-15 MuiInputBase-input `} onClick={handleOnClick} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} />
                    :
                    <video controls={props.controls} src={url} controlsList="nodownload" onClick={handleOnClick} className={`display-video`} />

                    // ${!props.controls ? classes.textMedia : classes.media}
                }
            </div>
    );
}

export default ImageOrVideo;
